/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Form } from 'antd';

import FormItem from '@/components/ui/FormItem';
import DatePicker from '@/components/ui/DatePicker';
import type { Task } from '@/components/ActionPlan/types';
import { I18n } from '@aws-amplify/core';

const { useFormInstance, useWatch } = Form;

export function DueDateFormItem(): JSX.Element {
	const form = useFormInstance();
	const taskList: Task[] = useWatch('task_list');

	useEffect(() => {
		if (taskList && taskList.length) {
			form.setFieldValue('task_list', taskList);
		}
	}, [taskList]);

	return (
		<FormItem label="Due date" name="due_date"  required>
			<DatePicker format="DD/MM/YYYY" placeholder={I18n.get('Due date')} />
		</FormItem>
	);
}
